export default {
    LINKEDIN_CLIENT_ID: '78zu1zfgbgryds'
}